export const JOB_ITEM = (id) => {
  return {
    id: `uid_id_${id}`,
    title: '',
    prev_text: '',
    city: {title: ''},
    contract: {title: ''},
    languages:[{title: ''}],
  }
}

export const ARTICLE_ITEM = (id) => {
  return {
    id: `uid_id_${id}`,
    img_url: '',
    title: '',
    prev_text: '',
    created_at: '',
    link: '',
  }
}

export const JOB_ITEM_LIST = (length = 4) => {
  return Array.from(Array(length).keys()).map(index => JOB_ITEM(index))
}

export const ARTICLE_ITEM_LIST = (length = 4) => {
  return Array.from(Array(length).keys()).map(index => ARTICLE_ITEM(index))
}
